import { authChannel } from "@/infra/auth/broadcast";
import UpdateIcon from "@/shared/icons/Update";
import { cn } from "@/shared/utils/classname-merger";
import { Card, CardBody, CardHeader } from "@nextui-org/react";
import { X } from "lucide-react";

export default function AppUpdateCard() {
  // Define your styles object
  const styles = {
    headerText: "text-[#52525B]",
    background: "bg-[#F4F4F5] ",
    bodyText: "text-[#27272A]"
  };

  const handleRefresh = () => {
    window.location.reload();
    // This will broadcast the message to all other tabs/windows
    authChannel.postMessage("appUpdated");
  }

  return (
    <div className="fixed bottom-5 right-5 z-50">
      <Card
        className={cn(
          "w-[471px]  rounded-lg outline-none border-[1px] relative pb-[5px]",
          styles.background,
        )}
      >
        <X
          onClick={() => handleRefresh()}
          size={14}
          className="absolute top-[15px] right-[15px] z-20 hover:cursor-pointer"
        />
        <CardHeader
          className={cn(styles.headerText, "pb-0 flex justify-between")}
        >
          <div className="flex flex-row gap-x-[8px]">
            <UpdateIcon color="#52525B" />
            <p className={cn(styles.headerText, "font-medium text-[16px]")}>
              Updated Version Available
            </p>
          </div>
        </CardHeader>
        <CardBody className={cn(styles.bodyText)}>
          <p className={cn(styles.bodyText, "text-[14px]")}>
            A new version of Zania is now available. { }
            <span onClick={() => handleRefresh()} className="text-[#006FEE] underline cursor-pointer">Refresh</span>  your browser to switch to the latest version.
          </p>
        </CardBody>
      </Card>
    </div>
  );
}